function isClipped(element, rect) {
  let node = element.parentElement;
  while (node && node !== document.body) {
    const style = window.getComputedStyle(node);
    const clips =
      style.overflow === "hidden" ||
      style.overflowY === "hidden" ||
      style.overflowX === "hidden";
    if (clips) {
      const parentRect = node.getBoundingClientRect();
      if (parentRect.width < 8 || parentRect.height < 8) return true;
      const overlapW = Math.min(rect.right, parentRect.right) - Math.max(rect.left, parentRect.left);
      const overlapH = Math.min(rect.bottom, parentRect.bottom) - Math.max(rect.top, parentRect.top);
      if (overlapW < 8 || overlapH < 8) return true;
    }
    node = node.parentElement;
  }
  return false;
}

export function isElementVisibleForTour(element) {
  if (!element || !element.isConnected) return false;
  const dropdown = element.closest(".sidebar-dropdown");
  if (dropdown && !dropdown.classList.contains("open")) return false;
  const sidebar = element.closest(".sidebar");
  if (sidebar?.classList.contains("sidebar-collapsed")) return false;
  const rect = element.getBoundingClientRect();
  if (rect.width < 8 || rect.height < 8) return false;
  return !isClipped(element, rect);
}

export function findTourTarget(key) {
  if (!key) return null;
  const nodes = Array.from(document.querySelectorAll(`[data-page-tour="${key}"]`));
  const pageNodes = nodes.filter((node) => !node.closest(".sidebar"));
  const pool = pageNodes.length ? pageNodes : nodes;
  return pool.find((node) => isElementVisibleForTour(node)) || null;
}

export function findFieldTarget(pageKey, fieldId) {
  if (!pageKey || !fieldId) return null;
  const nodes = Array.from(
    document.querySelectorAll(`[data-field-tour="${pageKey}:${fieldId}"]`)
  );
  return nodes.find((node) => isElementVisibleForTour(node)) || null;
}
